import { createPollingModel } from '@/shared/lib/query'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'

import { feedbackChangeStatus, feedbackCountQuery } from '../api'

export const FeedbacksActiveCountGate = createGate()

const updateFeedbacksActiveCount = createEvent()

export const $feedbacksActiveCount = feedbackCountQuery.$data.map(
  (data) => data?.count ?? 0,
)

sample({
  clock: updateFeedbacksActiveCount,
  fn: () => ({}),
  target: feedbackCountQuery.start,
})

const { startPolling, stopPolling } = createPollingModel(
  updateFeedbacksActiveCount,
)

sample({
  clock: FeedbacksActiveCountGate.open,
  target: [startPolling, updateFeedbacksActiveCount],
})

sample({
  clock: FeedbacksActiveCountGate.close,
  target: stopPolling,
})

sample({
  clock: feedbackChangeStatus.finished.success,
  target: updateFeedbacksActiveCount,
})
